import { Label } from './label.model';
import { OrderShippingTrackingPackageDetail } from './order-shipping-tracking-package-detail.model';

export class OrderShippingTrackingDetail {
    masterTrackingNumber: string;
    pickupTrackingNumber?: string;
    label: Label;
    packages: OrderShippingTrackingPackageDetail[];
}
